module.exports = __webpack_public_path__ + "img/tree-09-c-trunk.af0acc0a.png";